<template>
  <div class="s-main">
    <div class="main_left">
      <!--管理后台数据 start-->
      <div class="main_left_top">
        <div class="tag_wrap">
          <div class="tag"></div>
          <div class="tag_tit">{{ $t('dataAnalysis.synthesis.adminData.title') }}</div>
        </div>
        <div class="main_left_top_content">
          <div class="main_left_top_msg">
            <div class="main_left_top_msg_f">
              <div>
                <div class="tit_name">{{ $t('dataAnalysis.synthesis.adminData.teacherCount') }}</div>
                <div class="tit_num">{{ BiAdminData.teacherCount }}</div>
              </div>
              <div></div>
              <div>
                <div class="tit_name">{{ $t('dataAnalysis.synthesis.adminData.trainingRoomCount') }}</div>
                <div class="tit_num">{{ BiAdminData.trainingRoomCount }}</div>
              </div>
            </div>
          </div>
          <div class="main_left_top_msg">
            <div class="main_left_top_msg_f">
              <div>
                <div class="tit_name">{{ $t('dataAnalysis.synthesis.adminData.trainingEquipmentCount') }}</div>
                <div class="tit_num">{{ BiAdminData.trainingEquipmentCount }}</div>
              </div>
              <div></div>
              <div>
                <div class="tit_name">{{ $t('dataAnalysis.synthesis.adminData.trainingRoomApplyCount') }}</div>
                <div class="tit_num">{{ BiAdminData.trainingRoomApplyCount }}</div>
              </div>
            </div>
          </div>
          <div class="main_left_top_msg">
            <div class="main_left_top_msg_p">
              <div>
                <div class="tit_name overflow"><span :title="$t('dataAnalysis.synthesis.adminData.portalColumnCount')">{{ $t('dataAnalysis.synthesis.adminData.portalColumnCount') }}</span></div>
                <div class="tit_num">{{ BiAdminData.portalColumnCount }}</div>
              </div>
              <div>
                <div class="tit_name">{{ $t('dataAnalysis.synthesis.adminData.portalPressCount') }}</div>
                <div class="tit_num">{{ BiAdminData.portalPressCount }}</div>
              </div>
              <div>
                <div class="tit_name">{{ $t('dataAnalysis.synthesis.adminData.experimentCount') }}</div>
                <div class="tit_num">{{ BiAdminData.experimentCount }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 管理后台数据 end-->
      <!--各类实验的参与人数 start-->
      <div class="main_left_center">
        <div class="tag_wrap">
          <div class="tag"></div>
          <div class="tag_tit">{{ $t('dataAnalysis.synthesis.chartTitles.experimentParticipants') }}</div>
        </div>
        <div class="option">
          <div ref="option">
            <a-select
              :getPopupContainer="getCalendarContainerOption"
              style="width: 100%"
              :placeholder="$t('dataAnalysis.synthesis.other.pleaseSelect')"
              :disabled="Option.length == 0"
              allowClear
              @change="handleChange"
            >
              <a-select-option :value="item.id" v-for="(item, index) of Option" :key="index">
                {{ item.name }}
              </a-select-option>
            </a-select>
          </div>
          <div ref="time">
            <a-range-picker
              :getCalendarContainer="getCalendarContainerTime"
              @calendarChange="panelChange"
              :disabled-date="disableDate"
              format="MM-DD"
              @change="onChange"
            />
          </div>
        </div>
        <div class="echartD" ref="echartD"></div>
      </div>
      <!--各类实验的参与人数 end-->
      <!--课程数量占比 start-->
      <div class="main_left_bottom">
        <div class="tag_wrap">
          <div class="tag"></div>
          <div class="tag_tit">{{ $t('dataAnalysis.synthesis.chartTitles.courseRatio') }}</div>
        </div>
        <div class="echartG" ref="echartG"></div>
      </div>
      <!--课程数量占比 end-->
    </div>
    <div class="main_center">
      <!--资源数量 start-->
      <div class="main_center_top">
        <div class="main_center_top_name">
          <div class="tit">
            <img :src="require(`@/assets/${this.$i18n.locale}/bi_icon_zy.png`)" alt="" />
          </div>
          <div class="num">
            <div v-for="(item, index) in BiResData.resCount" :key="index">{{ item }}</div>
          </div>
        </div>
        <div class="main_center_top_et">
          <div>
            <div class="tag_wrap">
              <div class="tag"></div>
              <div class="tag_tit">{{ $t('dataAnalysis.synthesis.resourceData.schoolResourceRate') }}</div>
            </div>
            <div class="echartA" ref="echartA"></div>
          </div>
          <div>
            <div class="tag_wrap">
              <div class="tag"></div>
              <div class="tag_tit">{{ $t('dataAnalysis.synthesis.resourceData.resourceUsage') }}</div>
            </div>
            <div class="echartB" ref="echartB"></div>
          </div>
          <div>
            <div class="tag_wrap">
              <div class="tag"></div>
              <div class="tag_tit">{{ $t('dataAnalysis.synthesis.resourceData.resourceBrowsing') }}</div>
            </div>
            <div class="echartC" ref="echartC"></div>
          </div>
        </div>
      </div>
      <!--资源数量 end-->
      <div class="main_center_center">
        <!--最受欢迎资源排名 start-->
        <div class="left">
          <div class="tag_wrap">
            <div class="tag"></div>
            <div class="tag_tit">{{ $t('dataAnalysis.synthesis.chartTitles.popularResources') }}</div>
          </div>
          <div class="echartE" ref="echartE"></div>
        </div>
        <!--最受欢迎资源排名 end-->
        <!--备课使用最多的资源排名 start-->
        <div class="right">
          <div class="tag_wrap">
            <div class="tag"></div>
            <div class="tag_tit">{{ $t('dataAnalysis.synthesis.chartTitles.mostUsedResources') }}</div>
          </div>
          <div class="echartF" ref="echartF"></div>
        </div>
      </div>
      <!--备课使用最多的资源排名 end-->
      <div class="main_center_bottom">
        <!--老师备课占比 end-->
        <div class="left">
          <div class="tag_wrap">
            <div class="tag"></div>
            <div class="tag_tit">{{ $t('dataAnalysis.synthesis.chartTitles.teacherPrepRatio') }}</div>
          </div>
          <div class="echartH" ref="echartH"></div>
        </div>
        <!--老师备课占比 end-->
        <!--老师开课占比 start-->
        <div class="center">
          <div class="tag_wrap">
            <div class="tag"></div>
            <div class="tag_tit">{{ $t('dataAnalysis.synthesis.chartTitles.teacherCourseRatio') }}</div>
          </div>
          <div class="echartI" ref="echartI"></div>
        </div>
        <!--老师开课占比 end-->
        <!--老师播控占比 start-->
        <div class="right">
          <div class="tag_wrap">
            <div class="tag"></div>
            <div class="tag_tit">{{ $t('dataAnalysis.synthesis.chartTitles.teacherControlRatio') }}</div>
          </div>
          <div class="echartJ" ref="echartJ"></div>
        </div>
        <!--老师播控占比 end-->
      </div>
    </div>
    <div class="main_right">
      <!--教学数据分析 start-->
      <div class="main_right_top">
        <div class="tag_wrap">
          <div class="tag"></div>
          <div class="tag_tit">{{ $t('admin.analysis.bi.teachingData.title') }}</div>
        </div>
        <div class="main_right_top_content main_right_top_content_t">
          <div>
            <div class="tit_name">{{ $t('admin.analysis.bi.teachingData.prepCount') }}</div>
            <div class="tit_num">{{ BiLectureAnalyse.prepareLessonCount }}</div>
          </div>
          <div class="lint"></div>
          <div>
            <div class="tit_name">{{ $t('admin.analysis.bi.teachingData.courseware') }}</div>
            <div class="tit_num">{{ BiLectureAnalyse.creatorLessonCount }}</div>
          </div>
          <div class="lint"></div>
          <div>
            <div class="tit_name">{{ $t('admin.analysis.bi.teachingData.courseCount') }}</div>
            <div class="tit_num">{{ BiLectureAnalyse.lectureCount }}</div>
          </div>
        </div>
        <div class="main_right_top_content">
          <div>
            <div class="tit_name">{{ $t('admin.analysis.bi.teachingData.studentCount') }}</div>
            <div class="tit_num">{{ BiLectureAnalyse.lectureStudentCount }}</div>
          </div>
          <div class="lint"></div>
          <div>
            <div class="tit_name">{{ $t('admin.analysis.bi.teachingData.controlCount') }}</div>
            <div class="tit_num">{{ BiLectureAnalyse.openResCount }}</div>
          </div>
          <div class="lint"></div>
          <div>
            <div class="tit_name">{{ $t('admin.analysis.bi.teachingData.teachingResource') }}</div>
            <div class="tit_num">{{ BiLectureAnalyse.lectureResCount }}</div>
          </div>
        </div>
      </div>
      <!--教学数据分析 end-->
      <div class="main_right_center">
        <div class="main_right_center_content_wrap">
          <div class="main_right_center_content">
            <div><img :src="require('@/assets/icons/bi_icon1.png')" alt="" /></div>
            <div class="tit_name marR3">{{ $t('dataAnalysis.synthesis.adminData.teacherCount') }}:</div>
            <div class="tit_num">{{ BiAdminData.teacherCount }}</div>
          </div>
          <div class="main_right_center_content">
            <div><img :src="require('@/assets/icons/bi_icon2.png')" alt="" /></div>
            <div class="tit_name marR3">{{ $t('dataAnalysis.synthesis.adminData.studentCount') }}:</div>
            <div class="tit_num">{{ BiAdminData.studentCount }}</div>
          </div>
          <div class="main_right_center_content">
            <div><img :src="require('@/assets/icons/bi_icon3.png')" alt="" /></div>
            <div class="tit_name marR3">{{ $t('dataAnalysis.synthesis.adminData.classCount') }}:</div>
            <div class="tit_num">{{ BiAdminData.classCount }}</div>
          </div>
          <div class="main_right_center_content">
            <div><img :src="require('@/assets/icons/bi_icon4.png')" alt="" /></div>
            <div class="tit_name marR3">{{ $t('dataAnalysis.synthesis.adminData.testCount') }}:</div>
            <div class="tit_num">{{ BiAdminData.testCount }}</div>
          </div>
          <div class="main_right_center_content">
            <div><img :src="require('@/assets/icons/bi_icon5.png')" alt="" /></div>
            <div class="tit_name marR3">{{ $t('dataAnalysis.synthesis.adminData.examineCount') }}:</div>
            <div class="tit_num">{{ BiAdminData.examineCount }}</div>
          </div>
        </div>
      </div>
      <!--师生比例占比分析 start-->
      <div class="main_right_bottom">
        <div class="tag_wrap">
          <div class="tag"></div>
          <div class="tag_tit">{{ $t('dataAnalysis.synthesis.chartTitles.teacherStudentRatio') }}</div>
        </div>
        <div class="echartK" ref="echartK"></div>
      </div>
      <!--师生比例占比分析 end-->
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import moment from 'moment'
import {
  geExaminePeopleCountingOption,
  getBiAdminData,
  getBiLectureAnalyse,
  getBiLessonCountRate,
  getBiPplResRank,
  getBiResData,
  getBiResHotRank,
  getBiTeacherLectureRate,
  getBiTeacherOpenResRate,
  getBiTeacherPplRate,
  getExaminePeopleCounting
} from '@/api/chart'
import cookie from 'js-cookie'

export default {
  name: 'biAnalysis',
  data() {
    return {
      windowWidth: window.innerWidth,
      isFullscreen: false,
      echartA: null,
      echartB: null,
      echartC: null,
      echartD: null,
      echartE: null,
      echartF: null,
      echartG: null,
      echartH: null,
      echartI: null,
      echartJ: null,
      echartK: null,
      timer: null,
      currentDate: null,
      BiAdminData: {},
      BiLectureAnalyse: {},
      BiResData: {},
      Option: [],
      startTime: '',
      endTime: '',
      experimentId: '',
      colorGather: [
        '#3076F3',
        '#48B4FF',
        '#FDE076',
        '#43C391',
        '#FD9A4A',
        '#FFBA28',
        '#6B80DB',
        '#17BDBC',
        '#FF8B8A',
        '#9690FA'
      ],
      option: null,
      time: ''
    }
  },
  created() {},
  mounted() {
    this.initEcharts()
    this.getData()
    this.geExaminePeopleCountingOptionHttp()
    this.timer = setInterval(() => {
      this.getData()
    }, 5 * 6000)
    window.onresize = () => {
      this.echartA.resize()
      this.echartB.resize()
      this.echartC.resize()
      this.echartD.resize()
      this.echartE.resize()
      this.echartF.resize()
      this.echartG.resize()
      this.echartH.resize()
      this.echartI.resize()
      this.echartJ.resize()
      this.echartK.resize()
    }
  },
  beforeDestroy() {
    window.removeEventListener('fullscreenchange', this.onFullscreenChange)
    this.echartA.dispose()
    this.echartB.dispose()
    this.echartC.dispose()
    this.echartD.dispose()
    this.echartE.dispose()
    this.echartF.dispose()
    this.echartG.dispose()
    this.echartH.dispose()
    this.echartI.dispose()
    this.echartJ.dispose()
    this.echartK.dispose()
    clearInterval(this.timer)
  },
  methods: {
    initEcharts() {
      this.initEchartsA()
      this.initEchartsB()
      this.initEchartsC()
      this.initEchartsD()
      this.initEchartsE()
      this.initEchartsF()
      this.initEchartsG()
      this.initEchartsH()
      this.initEchartsI()
      this.initEchartsJ()
      this.initEchartsK()
    },
    initEchartsA(data = []) {
      const dataDefault = [
        { value: 10, name: this.$t('dataAnalysis.synthesis.other.model') },
        { value: 5, name: this.$t('dataAnalysis.synthesis.other.video') },
        { value: 15, name: this.$t('dataAnalysis.synthesis.other.text') },
        { value: 25, name: this.$t('dataAnalysis.synthesis.other.software') },
        { value: 20, name: this.$t('dataAnalysis.synthesis.other.audio') },
        { value: 20, name: this.$t('dataAnalysis.synthesis.other.image') }
      ]
      if (data.length === 0) data = dataDefault
      const dataLegend = []
      const colorArr = this.colorGather.slice(2).concat(this.colorGather.slice(0, 2))
      data.forEach((item, index) => {
        item.itemStyle = { color: colorArr[index] }
        dataLegend.push(item.name)
      })
      this.echartA = echarts.init(this.$refs.echartA)
      const optionTitle = {
        tooltip: {
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: {
            fontSize: 12
          },
          trigger: 'item',
          confine: true,
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },

        grid: {
          left: '0', // 调整左边距
          right: '0', // 调整右边距
          top: '0', // 调整上边距
          bottom: '0' // 调整下边距
        },
        legend: {
          bottom: '20%',
          right: '10%',
          width: '100',
          itemWidth: 7,
          itemHeight: 7,
          itemGap: 10,
          data: dataLegend
        },
        series: [
          {
            name: this.$t('dataAnalysis.synthesis.resourceData.schoolResourceRate'),
            type: 'pie',
            radius: [25, 45],
            label: {
              show: false
            },
            avoidLabelOverlap: true,
            emphasis: {
              label: {
                show: false,
                position: 'outer',
                alignTo: 'labelLine',
                formatter: '{b} : {d}%',
                bleedMargin: 10
              }
            },
            center: ['30%', '45%'],
            data
          }
        ]
      }
      this.echartA.setOption(optionTitle)
    },
    initEchartsB(data = []) {
      const dataDefault = [
        { value: 10, name: this.$t('dataAnalysis.synthesis.other.model') },
        { value: 5, name: this.$t('dataAnalysis.synthesis.other.video') },
        { value: 15, name: this.$t('dataAnalysis.synthesis.other.text') },
        { value: 25, name: this.$t('dataAnalysis.synthesis.other.software') },
        { value: 20, name: this.$t('dataAnalysis.synthesis.other.audio') },
        { value: 20, name: this.$t('dataAnalysis.synthesis.other.image') }
      ]
      if (data.length === 0) data = dataDefault

      const dataLegend = []
      const colorArr = this.colorGather.slice(3).concat(this.colorGather.slice(0, 3))
      data.forEach((item, index) => {
        item.itemStyle = { color: colorArr[index] }
        dataLegend.push(item.name)
      })
      this.echartB = echarts.init(this.$refs.echartB)
      const optionTitle = {
        tooltip: {
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: {
            fontSize: 12
          },
          trigger: 'item',
          confine: true,
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },

        grid: {
          left: '0', // 调整左边距
          right: '0', // 调整右边距
          top: '0', // 调整上边距
          bottom: '0' // 调整下边距
        },
        legend: {
          bottom: '20%',
          right: '10%',
          width: '100',
          itemWidth: 7,
          itemHeight: 7,
          itemGap: 10,
          data: dataLegend
        },
        series: [
          {
            name: this.$t('dataAnalysis.synthesis.resourceData.resourceUsage'),
            type: 'pie',
            radius: [25, 45],
            label: {
              show: false
            },
            avoidLabelOverlap: true,
            emphasis: {
              label: {
                show: false,
                position: 'outer',
                alignTo: 'labelLine',
                formatter: '{b} : {d}%',
                bleedMargin: 10
              }
            },
            center: ['30%', '45%'],
            data
          }
        ]
      }
      this.echartB.setOption(optionTitle)
    },
    initEchartsC(data = []) {
      const dataDefault = [
        { value: 10, name: this.$t('dataAnalysis.synthesis.other.model') },
        { value: 5, name: this.$t('dataAnalysis.synthesis.other.video') },
        { value: 15, name: this.$t('dataAnalysis.synthesis.other.text') },
        { value: 25, name: this.$t('dataAnalysis.synthesis.other.software') },
        { value: 20, name: this.$t('dataAnalysis.synthesis.other.audio') },
        { value: 20, name: this.$t('dataAnalysis.synthesis.other.image') }
      ]
      if (data.length === 0) data = dataDefault

      const dataLegend = []
      const colorArr = this.colorGather.slice(5).concat(this.colorGather.slice(0, 5))
      data.forEach((item, index) => {
        item.itemStyle = { color: colorArr[index] }
        dataLegend.push(item.name)
      })
      this.echartC = echarts.init(this.$refs.echartC)
      const optionTitle = {
        tooltip: {
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: {
            fontSize: 12
          },
          trigger: 'item',
          confine: true,
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        grid: {
          left: '0', // 调整左边距
          right: '0', // 调整右边距
          top: '0', // 调整上边距
          bottom: '0' // 调整下边距
        },
        legend: {
          bottom: '20%',
          right: '10%',
          width: '100',
          itemWidth: 7,
          itemHeight: 7,
          itemGap: 10,
          data: dataLegend
        },
        series: [
          {
            name: this.$t('dataAnalysis.synthesis.resourceData.resourceBrowsing'),
            type: 'pie',
            radius: [25, 45],
            label: {
              show: false
            },
            avoidLabelOverlap: true,
            emphasis: {
              label: {
                show: false,
                position: 'outer',
                alignTo: 'labelLine',
                formatter: '{b} : {d}%',
                bleedMargin: 10
              }
            },
            center: ['30%', '45%'],
            data
          }
        ]
      }
      this.echartC.setOption(optionTitle)
    },
    initEchartsD(x = [], y = []) {
      let xAxisArr = []
      let yAxisArr = []
      if (x.length === 0) {
        xAxisArr = [this.$t('dataAnalysis.synthesis.teachingDataPage.class1'), this.$t('dataAnalysis.synthesis.teachingDataPage.class2'), this.$t('dataAnalysis.synthesis.teachingDataPage.class3'), this.$t('dataAnalysis.synthesis.teachingDataPage.class4'), this.$t('dataAnalysis.synthesis.teachingDataPage.class5')]
        yAxisArr = [40, 37, 32, 25, 20]
      } else {
        xAxisArr = x
        yAxisArr = y
      }
      this.echartD = echarts.init(this.$refs.echartD)
      const optionTitle = {
        tooltip: {
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: {
            fontSize: 12
          },
          trigger: 'item',
          confine: true,
          formatter: '{a} <br/>{b} : {c} '
        },
        grid: {
          top: '10%',
          bottom: '40%' // 调整下边距
        },
        xAxis: {
          type: 'category',
          data: xAxisArr,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#E5E5E5',
              width: 1,
              type: 'solid'
            }
          },
          axisTick: {
            show: true
          },
          axisLabel: {
            //x轴文字的配置
            show: true,
            textStyle: {
              color: '#262626'
            }
          }
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: true,
            lineStyle: {
              show: true, //是否显示坐标轴轴线，
              color: '#E5E5E5', //x轴轴线的颜色
              width: 1, //x轴粗细
              type: 'solid'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dotted' //设置网格线类型 dotted：虚线 solid:实线
            }
          },
          axisTick: {
            show: false // 是否显示刻度
          },
          axisLabel: {
            color: '#868686', // x轴字体颜色
            interval: 0 //轴显示所有的数据
          }
        },
        series: [
          {
            name: this.$t('dataAnalysis.synthesis.chartTitles.experimentParticipants'),
            data: yAxisArr,
            type: 'bar',
            barWidth: 20,
            itemStyle: {
              color: '#6287FD' // 设置柱状图的颜色
            }
          }
        ]
      }
      this.echartD.setOption(optionTitle)
    },
    initEchartsE(x = [], y = []) {
      let xAxisArr = []
      let yAxisArr = []
      if (x.length === 0) {
        xAxisArr = [this.$t('dataAnalysis.synthesis.resources.motorcycleEngine'), this.$t('dataAnalysis.synthesis.resources.dualMainReducer'), this.$t('dataAnalysis.synthesis.resources.mechanicalArm'), this.$t('dataAnalysis.synthesis.resources.gear'), this.$t('dataAnalysis.synthesis.resources.workbench')]
        yAxisArr = [150, 120, 88, 75, 56]
      } else {
        xAxisArr = x
        yAxisArr = y
      }
      this.echartE = echarts.init(this.$refs.echartE)
      const optionTitle = {
        tooltip: {
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: {
            fontSize: 12
          },
          trigger: 'item',
          confine: true,
          formatter: '{a} <br/>{b} : {c} '
        },
        grid: {
          top: '15%',
          bottom: '25%' // 调整下边距
        },
        xAxis: {
          type: 'category',
          data: xAxisArr,
          width: 20,
          axisLine: {
            // show: true,
            lineStyle: {
              color: '#E5E5E5',
              width: 1,
              type: 'solid'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            //x轴文字的配置
            show: true,
            textStyle: {
              color: '#262626',
              fontSize: 12
            },
            // 核心代码 默认展示4个字超出显示...
            formatter: function(value) {
              //x轴的文字改为竖版显示
              var str = value.split('')
              return str.slice(0, 3).join('') + (str.length > 3 ? '...' : '')
            }
          }
        },
        yAxis: {
          type: 'value',
          name: this.$t('dataAnalysis.synthesis.other.quantity'),
          axisLine: {
            show: true,
            lineStyle: {
              show: true, //是否显示坐标轴轴线，
              color: '#E5E5E5', //x轴轴线的颜色
              width: 1 //x轴粗细
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dotted' //设置网格线类型 dotted：虚线 solid:实线
            }
          },
          axisTick: {
            show: false //是否显示刻度
          },
          axisLabel: {
            color: '#868686', // x轴字体颜色
            interval: 0 //轴显示所有的数据
          }
        },
        series: [
          {
            name: this.$t('dataAnalysis.synthesis.popularResources'),
            data: yAxisArr,
            type: 'bar',
            barWidth: 20,
            itemStyle: {
              color: '#FFB641' // 设置柱状图的颜色
            }
          }
        ]
      }
      this.echartE.setOption(optionTitle)
    },
    initEchartsF(x = [], y = []) {
      let xAxisArr = []
      let yAxisArr = []
      if (x.length === 0) {
        xAxisArr = [this.$t('dataAnalysis.synthesis.motorcycleEngine'), this.$t('dataAnalysis.synthesis.dualMainReducer'), this.$t('dataAnalysis.synthesis.mechanicalArm'), this.$t('dataAnalysis.synthesis.gear'), this.$t('dataAnalysis.synthesis.workbench')]
        yAxisArr = [100, 95, 83, 70, 65]
      } else {
        xAxisArr = x
        yAxisArr = y
      }
      this.echartF = echarts.init(this.$refs.echartF)
      const optionTitle = {
        tooltip: {
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: {
            fontSize: 12
          },
          trigger: 'item',
          confine: true,
          formatter: '{a} <br/>{b} : {c} '
        },
        grid: {
          top: '15%',
          bottom: '25%' // 调整下边距
        },
        xAxis: {
          type: 'category',
          data: xAxisArr,
          width: 20,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#E5E5E5',
              width: 1,
              type: 'solid'
            }
          },
          axisTick: {
            show: false
          },
          axisLabel: {
            //x轴文字的配置
            show: true,
            textStyle: {
              color: '#262626',
              fontSize: 12
            },
            // 核心代码 默认展示4个字超出显示...
            formatter: function(value) {
              //x轴的文字改为竖版显示
              var str = value.split('')
              return str.slice(0, 3).join('') + (str.length > 3 ? '...' : '')
            }
          }
        },
        yAxis: {
          type: 'value',
          name: this.$t('dataAnalysis.synthesis.other.quantity'),
          axisLine: {
            show: true,
            lineStyle: {
              show: true, //是否显示坐标轴轴线，
              color: '#E5E5E5', //x轴轴线的颜色
              width: 1 //x轴粗细
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dotted' //设置网格线类型 dotted：虚线 solid:实线
            }
          },
          axisTick: {
            show: false //是否显示刻度
          },
          axisLabel: {
            color: '#868686', // x轴字体颜色
            interval: 0 //轴显示所有的数据
          }
        },
        series: [
          {
            name: this.$t('dataAnalysis.synthesis.mostUsedResources'),
            data: yAxisArr,
            type: 'bar',
            barWidth: 20,
            itemStyle: {
              color: '#07CEB2' // 设置柱状图的颜色
            }
          }
        ]
      }
      this.echartF.setOption(optionTitle)
    },
    initEchartsG(data = []) {
      const dataDefault = [
        { value: 10, name: this.$t('dataAnalysis.synthesis.other.inProgress') },
        { value: 5, name: this.$t('dataAnalysis.synthesis.other.pending') },
        { value: 15, name: this.$t('dataAnalysis.synthesis.other.finished') }
      ]
      if (data.length === 0) data = dataDefault

      const dataLegend = []
      const colorArr = this.colorGather.slice(2).concat(this.colorGather.slice(0, 2))
      data.forEach((item, index) => {
        item.itemStyle = { color: colorArr[index] }
        dataLegend.push(item.name)
      })
      this.echartG = echarts.init(this.$refs.echartG)
      const optionTitle = {
        tooltip: {
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: {
            fontSize: 12
          },
          trigger: 'item',
          confine: true,
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },

        grid: {
          left: '0', // 调整左边距
          right: '0', // 调整右边距
          top: '0', // 调整上边距
          bottom: '0' // 调整下边距
        },
        legend: {
          bottom: '18%',
          right: 'center',
          width: '180',
          itemWidth: 7,
          itemHeight: 7,
          itemGap: 10,
          data: dataLegend
        },
        series: [
          {
            name: this.$t('dataAnalysis.synthesis.chartTitles.courseRatio'),
            type: 'pie',
            radius: [25, 60],
            label: {
              show: false
            },
            avoidLabelOverlap: true,
            emphasis: {
              label: {
                show: false,
                position: 'outer',
                alignTo: 'labelLine',
                formatter: '{b} : {d}%',
                bleedMargin: 10
              }
            },
            center: ['50%', '35%'],
            data
          }
        ]
      }
      this.echartG.setOption(optionTitle)
    },
    initEchartsH(data = []) {
      const dataDefault = []
      if (data.length === 0) data = dataDefault
      const dataLegend = []
      const colorArr = this.colorGather.slice(4).concat(this.colorGather.slice(0, 4))
      data.forEach((item, index) => {
        item.itemStyle = { color: colorArr[index] }
        dataLegend.push(item.name)
      })
      this.echartH = echarts.init(this.$refs.echartH)
      const optionTitle = {
        tooltip: {
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: {
            fontSize: 12
          },
          trigger: 'item',
          confine: true,
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },

        grid: {
          left: '0', // 调整左边距
          right: '0', // 调整右边距
          top: '0', // 调整上边距
          bottom: '0' // 调整下边距
        },
        legend: {
          bottom: '18%',
          right: 'center',
          width: '180',
          itemWidth: 7,
          itemHeight: 7,
          itemGap: 10,
          data: dataLegend,
          type: 'scroll',
          pageIconSize: 10,
          pageButtonGap: 10, // 开启图例分页
          pageButtonItemGap: 5 // 图例分页按钮间隔
        },
        series: [
          {
            name: this.$t('dataAnalysis.synthesis.chartTitles.teacherPrepRatio'),
            type: 'pie',
            radius: [25, 60],
            label: {
              show: false
            },
            avoidLabelOverlap: true,
            emphasis: {
              label: {
                show: false,
                position: 'outer',
                alignTo: 'labelLine',
                formatter: '{b} : {d}%',
                bleedMargin: 10
              }
            },
            center: ['50%', '35%'],
            data
          }
        ]
      }
      this.echartH.setOption(optionTitle)
    },
    initEchartsI(data = []) {
      const dataDefault = [
        { value: 10, name: this.$t('dataAnalysis.synthesis.other.model') },
        { value: 5, name: this.$t('dataAnalysis.synthesis.other.video') },
        { value: 15, name: this.$t('dataAnalysis.synthesis.other.text') },
        { value: 25, name: this.$t('dataAnalysis.synthesis.other.software') },
        { value: 20, name: this.$t('dataAnalysis.synthesis.other.audio') },
        { value: 20, name: this.$t('dataAnalysis.synthesis.other.image') }
      ]
      if (data.length === 0) data = dataDefault

      const dataLegend = []
      const colorArr = this.colorGather.slice(6).concat(this.colorGather.slice(0, 6))
      data.forEach((item, index) => {
        item.itemStyle = { color: colorArr[index] }
        dataLegend.push(item.name)
      })
      this.echartI = echarts.init(this.$refs.echartI)
      const optionTitle = {
        tooltip: {
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: {
            fontSize: 12
          },
          trigger: 'item',
          confine: true,
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },

        grid: {
          left: '0', // 调整左边距
          right: '0', // 调整右边距
          top: '0', // 调整上边距
          bottom: '0' // 调整下边距
        },
        legend: {
          bottom: '18%',
          right: 'center',
          width: '180',
          itemWidth: 7,
          itemHeight: 7,
          itemGap: 10,
          data: dataLegend,
          type: 'scroll',
          pageIconSize: 10,
          pageButtonGap: 10, // 开启图例分页
          pageButtonItemGap: 5 // 图例分页按钮间隔
        },
        series: [
          {
            name: this.$t('dataAnalysis.synthesis.chartTitles.teacherCourseRatio'),
            type: 'pie',
            radius: [25, 60],
            label: {
              show: false
            },
            avoidLabelOverlap: true,
            emphasis: {
              label: {
                show: false,
                position: 'outer',
                alignTo: 'labelLine',
                formatter: '{b} : {d}%',
                bleedMargin: 10
              }
            },
            center: ['50%', '35%'],
            data
          }
        ]
      }
      this.echartI.setOption(optionTitle)
    },
    initEchartsJ(data = []) {
      const dataDefault = [
        { value: 10, name: this.$t('dataAnalysis.synthesis.other.model') },
        { value: 5, name: this.$t('dataAnalysis.synthesis.other.video') },
        { value: 15, name: this.$t('dataAnalysis.synthesis.other.text') },
        { value: 25, name: this.$t('dataAnalysis.synthesis.other.software') },
        { value: 20, name: this.$t('dataAnalysis.synthesis.other.audio') },
        { value: 20, name: this.$t('dataAnalysis.synthesis.other.image') }
      ]
      if (data.length === 0) data = dataDefault

      const dataLegend = []
      const colorArr = this.colorGather.slice(8).concat(this.colorGather.slice(0, 8))
      data.forEach((item, index) => {
        item.itemStyle = { color: colorArr[index] }
        dataLegend.push(item.name)
      })
      this.echartJ = echarts.init(this.$refs.echartJ)
      const optionTitle = {
        tooltip: {
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: {
            fontSize: 12
          },
          trigger: 'item',
          confine: true,
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },

        grid: {
          left: '0', // 调整左边距
          right: '0', // 调整右边距
          top: '0', // 调整上边距
          bottom: '0' // 调整下边距
        },
        legend: {
          bottom: '18%',
          right: 'center',
          width: '180',
          itemWidth: 7,
          itemHeight: 7,
          itemGap: 10,
          data: dataLegend,
          type: 'scroll',
          pageIconSize: 10,
          pageButtonGap: 10, // 开启图例分页
          pageButtonItemGap: 5 // 图例分页按钮间隔
        },
        series: [
          {
            name: this.$t('dataAnalysis.synthesis.chartTitles.teacherControlRatio'),
            type: 'pie',
            radius: [25, 60],
            label: {
              show: false
            },
            avoidLabelOverlap: true,
            emphasis: {
              label: {
                show: false,
                position: 'outer',
                alignTo: 'labelLine',
                formatter: '{b} : {d}%',
                bleedMargin: 10
              }
            },
            center: ['50%', '35%'],
            data
          }
        ]
      }
      this.echartJ.setOption(optionTitle)
    },
    initEchartsK(data = []) {
      const dataDefault = [
        { value: 10, name: this.$t('dataAnalysis.synthesis.other.allCollegeTeachers') },
        { value: 420, name: this.$t('dataAnalysis.synthesis.other.allCollegeStudents') }
      ]
      if (data.length === 0) data = dataDefault

      const dataLegend = []
      const colorArr = ['#43C391', '#FFBA28']
      data.forEach((item, index) => {
        item.itemStyle = { color: colorArr[index] }
        dataLegend.push(item.name)
      })
      this.echartK = echarts.init(this.$refs.echartK)
      const optionTitle = {
        tooltip: {
          backgroundColor: 'rgba(50,50,50,0.9)',
          textStyle: {
            fontSize: 12
          },
          trigger: 'item',
          confine: true,
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },

        grid: {
          left: '0', // 调整左边距
          right: '0', // 调整右边距
          top: '0', // 调整上边距
          bottom: '0' // 调整下边距
        },
        legend: {
          bottom: '18%',
          right: 'center',
          width: '300',
          itemWidth: 7,
          itemHeight: 7,
          itemGap: 10,
          data: dataLegend
        },
        series: [
          {
            name: this.$t('dataAnalysis.synthesis.chartTitles.teacherStudentRatio'),
            type: 'pie',
            radius: [25, 60],
            label: {
              show: false
            },
            avoidLabelOverlap: true,
            emphasis: {
              label: {
                show: false,
                position: 'outer',
                alignTo: 'labelLine',
                formatter: '{b} : {d}%',
                bleedMargin: 10
              }
            },
            center: ['50%', '35%'],
            data
          }
        ]
      }
      this.echartK.setOption(optionTitle)
    },
    getData() {
      // 管理后台数据
      this.getBiAdminDataHttp()
      // 教学数据分析
      this.getBiLectureAnalyseHttp()
      //资源数据
      this.getBiResDataHttp()
      // 各类实验的参与人数
      this.getExaminePeopleCountingHttp()
      // //最受欢迎资源排名
      this.getBiResHotRankHttp()
      // //备课使用最多的资源排名
      this.getBiPplResRankHttp()
      // //课程数量占比
      this.getBiLessonCountRateHttp()
      // // 老师备课占比
      this.getBiTeacherPplRateHttp()
      // // 老师开课占比
      this.getBiTeacherLectureRateHttp()
      // 老师播控占比
      this.getBiTeacherOpenResRateHttp()
    },
    // 管理后台数据
    getBiAdminDataHttp() {
      getBiAdminData().then(res => {
        if (res.code === 200) {
          // if(res.data.teacherCount!==0 && res.data.studentCount!==0){
          //   arr=[
          //     { value: res.data.teacherCount, name: '所有学院老师' },
          //     { value: res.data.studentCount, name: '所有学院学生' },
          //   ]
          //   this.initEchartsK(arr)
          // }else if(res.data.teacherCount===0 && res.data.studentCount!==0){
          //   arr=[
          //     { value: 0, name: '所有学院老师' },
          //     { value: res.data.studentCount, name: '所有学院学生' },
          //   ]
          //   this.initEchartsK(arr)
          // }else if(res.data.studentCount===0 && res.data.teacherCount!==0){
          //   arr=[
          //     { value: res.data.teacherCount, name: '所有学院老师' },
          //     { value: 0, name: '所有学院学生' },
          //   ]
          //   this.initEchartsK(arr)
          // }
          // 门户数量为零时 随机5-10
          res.data.portalColumnCount == 0
            ? (res.data.portalColumnCount = this.getRandomInt(5, 10))
            : res.data.portalColumnCount
          // 新闻数量为零时 随机5-10
          res.data.portalPressCount == 0
            ? (res.data.portalPressCount = this.getRandomInt(5, 10))
            : res.data.portalPressCount
          // 实验数量为零时 随机5-10
          res.data.experimentCount == 0
            ? (res.data.experimentCount = this.getRandomInt(5, 10))
            : res.data.experimentCount
          // 老师数量为零时 随机5-10
          res.data.teacherCount == 0 ? (res.data.teacherCount = this.getRandomInt(5, 10)) : res.data.teacherCount
          // 学生数量为零时 随机5-10
          res.data.studentCount == 0 ? (res.data.studentCount = this.getRandomInt(5, 10)) : res.data.studentCount
          // 班级数量为零时 随机5-10
          res.data.classCount == 0 ? (res.data.classCount = this.getRandomInt(5, 10)) : res.data.classCount
          // 理论考核次数为零时 随机5-10
          res.data.testCount == 0 ? (res.data.testCount = this.getRandomInt(5, 10)) : res.data.testCount
          // 实验考核次数为零时 随机5-10
          res.data.examineCount == 0 ? (res.data.examineCount = this.getRandomInt(5, 10)) : res.data.examineCount
          let arr = []
          arr = [
            { value: res.data.teacherCount, name: this.$t('dataAnalysis.synthesis.other.allCollegeTeachers') },
            { value: res.data.studentCount, name: this.$t('dataAnalysis.synthesis.other.allCollegeStudents') }
          ]
          this.initEchartsK(arr)
          this.BiAdminData = res.data
        }
      })
    },
    // 教学数据分析
    getBiLectureAnalyseHttp() {
      getBiLectureAnalyse().then(res => {
        if (res.code === 200) {
          // 讲授资源为零时 随机5-10
          res.data.lectureResCount == 0
            ? (res.data.lectureResCount = this.getRandomInt(5, 10))
            : res.data.lectureResCount
          //上课人数为零时 随机5-10
          res.data.lectureStudentCount == 0
            ? (res.data.lectureStudentCount = this.getRandomInt(5, 10))
            : res.data.lectureStudentCount

          this.BiLectureAnalyse = res.data
        }
      })
    },
    //资源数据
    getBiResDataHttp() {
      getBiResData().then(res => {
        if (res.code === 200) {
          res.data.resCount = res.data.resCount.toString().split('')
          this.BiResData = res.data
          this.initEchartsA(this.BiResData.resTypeRate)
          this.initEchartsB(this.BiResData.resUseRate)
          if (res.data.resPlayerRate.length == 0) {
            let arr = []
            let arr1 = [
              this.$t('dataAnalysis.synthesis.other.model'),
              this.$t('dataAnalysis.synthesis.other.software'),
              this.$t('dataAnalysis.synthesis.other.video'),
              this.$t('dataAnalysis.synthesis.other.text'),
              this.$t('dataAnalysis.synthesis.other.audio'),
              this.$t('dataAnalysis.synthesis.other.image')
            ]
            let arr2 = this.generateRandomNumbers(300, 6)
            for (let i = 0; i < arr1.length; i++) {
              arr.push({
                name: arr1[i],
                value: arr2[i]
              })
            }
            this.initEchartsC(arr)
          } else {
            this.initEchartsC(this.BiResData.resPlayerRate)
          }
        }
      })
    },
    // 各类实验的参与人数-筛选项
    geExaminePeopleCountingOptionHttp() {
      geExaminePeopleCountingOption().then(res => {
        if (res.code === 200) {
          this.Option = res.data.list
        }
      })
    },
    // 各类实验的参与人数
    getExaminePeopleCountingHttp(params) {
      getExaminePeopleCounting(params).then(res => {
        if (res.code === 200) {
          let x = []
          let y = []
          if (res.data.list.length !== 0) {
            for (let item of res.data.list) {
              x.push(item.name)
              y.push(item.value)
            }
          }
          this.initEchartsD(x, y)
        }
      })
    },
    // 最受欢迎资源排名
    getBiResHotRankHttp() {
      getBiResHotRank().then(res => {
        if (res.code === 200) {
          let x = []
          let y = []
          if (res.data.list.length !== 0) {
            for (let item of res.data.list) {
              x.push(item.name)
              y.push(item.value)
            }
          }
          this.initEchartsE(x, y)
        }
      })
    },
    // 备课使用最多的资源排名
    getBiPplResRankHttp() {
      getBiPplResRank().then(res => {
        if (res.code === 200) {
          let x = []
          let y = []
          if (res.data.list.length !== 0) {
            for (let item of res.data.list) {
              x.push(item.name)
              y.push(item.value)
            }
          }
          this.initEchartsF(x, y)
        }
      })
    },
    //课程数量占比
    getBiLessonCountRateHttp() {
      getBiLessonCountRate().then(res => {
        if (res.code === 200) {
          if (res.data.list.length == 0) {
            let arr = []
            let arr1 = [
              this.$t('dataAnalysis.synthesis.other.inProgress'),
              this.$t('dataAnalysis.synthesis.other.pending'),
              this.$t('dataAnalysis.synthesis.other.finished')
            ]
            let arr2 = this.generateRandomNumbers(100, 3)
            for (let i = 0; i < arr1.length; i++) {
              arr.push({
                name: arr1[i],
                value: arr2[i]
              })
            }
            this.initEchartsG(arr)
          } else {
            this.initEchartsG(res.data.list)
          }
        }
      })
    },
    // 老师备课占比
    getBiTeacherPplRateHttp() {
      getBiTeacherPplRate().then(res => {
        if (res.code === 200) {
          if (res.data.list.length == 0) {
            let arr = []
            let arr1 = [
              'Mr. Smith',
              'Ms. Johnson',
              'Mr. Brown',
              'Ms. Davis',
              'Mr. Wilson',
              this.$t('common.other')
            ]
            let arr2 = this.generateRandomNumbers(100, 6)
            for (let i = 0; i < arr1.length; i++) {
              arr.push({
                name: this.$i18n.locale === 'zh-CN' ? [this.$t('dataAnalysis.synthesis.teachers.wang'), this.$t('dataAnalysis.synthesis.teachers.zhang'), this.$t('dataAnalysis.synthesis.teachers.liu'), this.$t('dataAnalysis.synthesis.teachers.li'), this.$t('dataAnalysis.synthesis.teachers.sun'), this.$t('dataAnalysis.synthesis.other.other')][i] : arr1[i],
                value: arr2[i]
              })
            }
            this.initEchartsH(arr)
          } else {
            this.initEchartsH(res.data.list)
          }
        }
      })
    },
    // 老师开课占比
    getBiTeacherLectureRateHttp() {
      getBiTeacherLectureRate().then(res => {
        if (res.code === 200) {
          if (res.data.list.length == 0) {
            let arr = []
            let arr1 = [
              'Mr. Smith',
              'Ms. Johnson',
              'Mr. Brown',
              'Ms. Davis',
              'Mr. Wilson',
              this.$t('common.other')
            ]
            let arr2 = this.generateRandomNumbers(100, 6).sort(function(a, b) {
              return b - a
            })
            for (let i = 0; i < arr1.length; i++) {
              arr.push({
                name: this.$i18n.locale === 'zh-CN' ? [this.$t('dataAnalysis.synthesis.teachers.wang'), this.$t('dataAnalysis.synthesis.teachers.zhang'), this.$t('dataAnalysis.synthesis.teachers.liu'), this.$t('dataAnalysis.synthesis.teachers.li'), this.$t('dataAnalysis.synthesis.teachers.sun'), this.$t('dataAnalysis.synthesis.other.other')][i] : arr1[i],
                value: arr2[i]
              })
            }
            this.initEchartsI(arr)
          } else {
            this.initEchartsI(res.data.list)
          }
        }
      })
    },
    //老师播控占比
    getBiTeacherOpenResRateHttp() {
      getBiTeacherOpenResRate().then(res => {
        if (res.code === 200) {
          if (res.data.list.length == 0) {
            let arr = []
            let arr1 = [
              'Mr. Smith',
              'Ms. Johnson',
              'Mr. Brown',
              'Ms. Davis',
              'Mr. Wilson',
              this.$t('common.other')
            ]
            let arr2 = this.generateRandomNumbers(100, 6).sort(function(a, b) {
              return b - a
            })
            for (let i = 0; i < arr1.length; i++) {
              arr.push({
                name: this.$i18n.locale === 'zh-CN' ? [this.$t('dataAnalysis.synthesis.teachers.wang'), this.$t('dataAnalysis.synthesis.teachers.zhang'), this.$t('dataAnalysis.synthesis.teachers.liu'), this.$t('dataAnalysis.synthesis.teachers.li'), this.$t('dataAnalysis.synthesis.teachers.sun'), this.$t('dataAnalysis.synthesis.other.other')][i] : arr1[i],
                value: arr2[i]
              })
            }
            this.initEchartsJ(arr)
          } else {
            this.initEchartsJ(res.data.list)
          }
        }
      })
    },
    // 各类实验的参与人数 日历
    onChange(date, dateString) {
      console.log(date, dateString)
      if (dateString[0] == '') {
        this.startTime = ''
        this.endTime = ''
      } else {
        this.startTime = moment(moment(date[0]._d).format('YYYY-MM-DD')).format('YYYY-MM-DD')
        this.endTime = moment(moment(date[1]._d).format('YYYY-MM-DD')).format('YYYY-MM-DD')
      }
      let param = {
        startTime: this.startTime,
        endTime: this.endTime,
        experimentId: this.experimentId
      }
      this.getExaminePeopleCountingHttp(param)
    },
    // 各类实验的参与人数 下拉
    handleChange(value) {
      let param = {}
      if (value == undefined) {
        param = {
          startTime: this.startTime,
          endTime: this.endTime,
          experimentId: ''
        }
      } else {
        param = {
          startTime: this.startTime,
          endTime: this.endTime,
          experimentId: value
        }
      }
      this.getExaminePeopleCountingHttp(param)
    },
    panelChange(date, dateString) {
      if (date[0] && !date[1]) {
        this.currentDate = date[0]
      } else if (date[0] && date[1]) {
        this.currentDate = null
      }
    },
    getCalendarContainerTime() {
      return this.$refs.time
    },
    getCalendarContainerOption() {
      return this.$refs.option
    },
    disableDate(time) {
      if (this.currentDate) {
        const one = 5 * 24 * 3600 * 1000
        const minTime = this.currentDate - one
        // 当前日期 + one = 5天之后
        const maxTime = this.currentDate + one
        return time < minTime || time > maxTime
      } else {
        return null
      }
    },
    // 随机数
    getRandomInt(min, max) {
      min = Math.ceil(min)
      max = Math.floor(max)
      return Math.floor(Math.random() * (max - min + 1)) + min
    },
    // 瓜分指定总数 生成随机数瓜分
    generateRandomNumbers(sum, count) {
      let arr = new Array(count).fill(0)
      for (let i = 0; i < sum; i++) {
        var num = parseInt((Math.random() * count).toString())
        arr[num]++
      }
      return arr
    }
  }
}
</script>

<style scoped lang="less">
.content {
  background-image: url(~@/assets/img/bi_bj.png) !important;
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
  position: relative;
  width: 100%;

  overflow: hidden !important;
  .wrap {
    height: calc(93% - 18px);
    overflow-y: auto;
    margin-top: 101px;
  }
  .top_full {
    position: absolute;
    right: 50px;
    top: 28px;
    .icon {
      font-size: 20px;
    }
  }
  .top_tit {
    position: absolute;
    top: 4%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    img {
      width: 46%;
    }
  }

  .s-main {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 0px auto 0 auto;
    overflow-y: auto;
    position: relative;
    height: 100%;
    .tag_wrap {
      display: flex;
      .tag {
        width: 4px;
        height: 12px;
        background: #6b738c;
        border-radius: 2px;
        margin-right: 12px;
        margin-top: 5px;
      }
      .tag_tit {
        font-weight: 600;
        font-size: 14px;
        color: #6b738c;
      }
    }
    .tit_name {
      font-weight: 500;
      font-size: 12px;
      color: #585858;
    }
    .tit_num {
      font-weight: 400;
      font-size: 16px;
      color: #000000;
    }
    .marR3 {
      margin-right: 3px;
    }
    .main_left {
      width: 19%;
      .main_left_top {
        padding: 8px 0 0 14px;
        background: #fff;
        border-radius: 4px;
        //margin-top: 5px;
        min-height: 236px;
        height: calc(33%);
        overflow: hidden;
        .main_left_top_content {
          margin-top: 27px;
          padding-bottom: 14px;
        }
        &_msg {
          margin-top: calc(100% - 92%);
          padding-left: 8px;
          padding-right: 10px;
          &_f {
            display: flex;
            justify-content: space-between;
          }
          &_f > div:nth-child(1),
          &_f > div:nth-child(3) {
            width: 40%;
            text-align: left;
          }
          &_f > div:nth-child(2) {
            width: 1px;
            height: 26px;
            border: 1px solid #f3f3f3;
            margin-top: 4px;
            margin-right: 10%;
          }
          &_p {
            display: flex;
            justify-content: space-between;
            & > div {
              width: 33%;
            }
          }
        }
      }
      .main_left_center {
        overflow: hidden;
        width: 100%;
        min-height: 245px;
        height: calc(34.9%);
        background: #ffffff;
        border-radius: 4px;
        padding: 8px 0 0 14px;
        margin-top: 9px;
        .option {
          display: flex;
          justify-content: space-around;
          margin-top: 6px;
          width: 92%;
          & > div:nth-child(1) {
            width: 40%;
          }
          & > div:nth-child(2) {
            width: 50%;
          }
        }
      }
      .main_left_bottom {
        width: 100%;
        min-height: 222px;
        height: calc(31.6%);
        background: #ffffff;
        border-radius: 4px;
        padding: 8px 0 0 14px;
        margin-top: 9px;
      }
    }
    .main_center {
      width: 60%;
      position: relative;
      .main_center_top {
        min-height: 236px;
        height: calc(33%);
        overflow: hidden;
        .main_center_top_name {
          position: absolute;
          top: 53px;
          left: 50%;
          transform: translate(-50%, -50%);
          .tit {
            text-align: center;
            img {
              // width: 106px;
              height: 23px;
            }
          }
          .num {
            display: flex;
            justify-content: center;
            margin: 17px auto 27px auto;
            & > div {
              margin: 0 6px;
              text-align: center;
              line-height: 30px;
              width: 30px;
              height: 30px;
              background: linear-gradient(127deg, #fda74f 0%, #ffb43d 100%);
              box-shadow: inset 0px 0px 10px 0px rgba(255, 255, 255, 0.5);
              border-radius: 3px;
              font-weight: normal;
              font-size: 22px;
              color: #ffffff;
            }
          }
        }
        .main_center_top_et {
          display: flex;
          justify-content: space-between;
          padding-top: 94px;
          min-height: 147px;
          height: 100%;
          & > div {
            width: 32.3%;
            height: 100%;
            background: #ffffff;
            border-radius: 4px;
            padding: 8px 0 0 14px;
          }
        }
      }
      .main_center_center {
        min-height: 245px;
        height: calc(34.9%);
        margin-top: 9px;
        display: flex;
        justify-content: space-between;
        overflow: hidden;
        .left {
          background: #ffffff;
          border-radius: 4px;
          padding: 8px 0 0 14px;
          width: 49.2%;
        }
        .right {
          background: #ffffff;
          border-radius: 4px;
          padding: 8px 0 0 14px;
          width: 49.2%;
        }
      }
      .main_center_bottom {
        width: 100%;
        min-height: 222px;
        height: calc(31.6%);
        margin-top: 9px;
        display: flex;
        justify-content: space-between;
        overflow: hidden;
        .left {
          width: 32.5%;
          height: 100%;
          background: #ffffff;
          border-radius: 4px;
          padding: 8px 0 0 14px;
        }
        .center {
          width: 32.5%;
          height: 100%;
          background: #ffffff;
          border-radius: 4px;
          padding: 8px 0 0 14px;
        }
        .right {
          width: 32.5%;
          height: 100%;
          background: #ffffff;
          border-radius: 4px;
          padding: 8px 0 0 14px;
        }
      }
    }
    .main_right {
      width: 19%;
      .main_right_top {
        width: 100%;
        min-height: 183px;
        height: calc(26%);
        background: #ffffff;
        border-radius: 4px;
        padding: 8px 0 25px 14px;
        overflow: hidden;
        .main_right_top_content_t {
          margin-top: 27px !important;
        }
        .main_right_top_content {
          display: flex;
          justify-content: space-around;
          margin-top: 10%;
          .lint {
            width: 1px;
            height: 26px;
            border: 1px solid #f3f3f3;
            margin-top: 4px;
          }
        }
      }
      .main_right_center {
        margin-top: 9px;
        width: 100%;
        min-height: 298px;
        height: calc(41.9%);
        background: #ffffff;
        border-radius: 4px;
        overflow: hidden;
        .main_right_center_content_wrap {
          //padding-top: 10px;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-around;
        }
        .main_right_center_content {
          display: flex;
          margin: 0 auto;
          width: 89%;
          min-height: 44px;
          height: calc(16%);
          //line-height: 44px;
          background: #f8f8f8;
          border-radius: 2px;
          & > div:nth-child(1) {
            margin-right: 12px;
            margin-left: 22px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            img {
              width: 26px;
              height: 26px;
            }
          }
          & > div:nth-child(2) {
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
          & > div:nth-child(3) {
            display: flex;
            flex-direction: column;
            justify-content: center;
          }
        }
      }
      .main_right_bottom {
        overflow: hidden;
        width: 100%;
        min-height: 222px;
        height: calc(31.6%);
        background: #ffffff;
        border-radius: 4px;
        padding: 8px 0 0 14px;
        border-radius: 4px;
        margin-top: 9px;
        position: relative;
      }
    }
  }

  .echartA,
  .echartB,
  .echartC,
  .echartD,
  .echartE,
  .echartF,
  .echartG,
  .echartH,
  .echartI,
  .echartJ,
  .echartK {
    width: 100%;
    height: 100%;
  }
}

/deep/ .ant-calendar-range-picker-input {
  width: 50% !important;
}
/deep/.ant-calendar-picker-input {
  display: flex;
  border-radius: 40px;
}
/deep/ .ant-select-selection--single {
  border-radius: 40px;
}
.fullscreen {
  position: absolute;
  top: 0;
  left: 0;
  width: 100% !important;
  height: 100% !important;
  z-index: 999;
}
.overflow {
  max-width: 70%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
@media screen and (min-height: 960px) and (max-height: 1400px) {
  .main .main_left .main_left_top_msg {
    margin-top: calc(100% - 88%);
  }
  .main_right_top_content {
    margin-top: 15% !important;
  }
  .main .main_right .main_right_top .main_right_top_content_t {
    margin-top: 15% !important;
  }
}
</style>
